const _allMensagens = [
	{
		val: 'APRESENTACAO',
		text: 'Apresentação',
		departamento: '6',
		mensagens: [
			`Boa tarde %nome_contato%, como posso ajudar?`,
			`Bom dia %nome_contato%, como posso ajudar?`,
			`Olá %nome_contato%, peço que não se esqueça de avaliar o atendimento no encerramento do chat. Como posso ajudar?`,
		]
	},
	{
		val: 'CODIGO',
		text: 'Códigos',
		departamento: '6',
		mensagens: [
			`Código 52 - Verifique as atualizações do seu Sistema Operacional e instale; - Reinicie o computador e verifique se não existem novas atualizações; - Realizada as atualizações o drive deve ser instalado corretamente sem problemas, caso continue com alerta tente realizar uma nova instalação.`,
			`Por gentileza, informe o código do produto. Este código encontra-se na etiqueta branca da Gertec e possui 8 dígitos. Está entre a descrição e o número de série.`,
		]
	},
	{
		val: 'ASSISTENCIA',
		text: 'Assistência',
		departamento: '6',
		mensagens: [
			`Encontre a Assistência Técnica mais próxima de você. https://www.gertec.com.br/suporte/assistencia-tecnica/ Ao encontrar a assistência mais próxima, entre em contato por telefone e verifique se a mesma realiza o reparo do produto em questão. Políticas de Envio para Reparo: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Telefone da Assistência: (11) 2173-6500 Observação: Para os equipamentos PINPAD e GERSAT(SAT), deve ser enviado para a Assistência da Gertec, conforme mostra nas nossas políticas de envio. Caso o envio não seja enviado para a assistência da Gertec(Diadema - SP) indicada nas políticas a assistência autorizada apenas fará o envio para a Gertec, o que pode estender o tempo para retorno e custo.`,
			`Caro cliente, recomendamos que para consultar o endereço da Assistência Técnica Gertec veja diretamente no site da Gertec. Consulte no site: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Dados da Gertec – Unidade de Serviços Gertec Brasil Ltda. CNPJ 03.654.119/0004-19 I.E 286.502.952.112 I.M 75419 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Obrigado.`,
			'Para enviar seu equipamento para a Assistência, siga nossa política de envio no link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/. Caso tenha qualquer dúvida entre em contato com a Gertec, através dos canais: E-mail: astecnica@gertec.com.br Telefone 011 2173-6500.'
		]
	},
	{
		val: 'ERROS',
		text: 'Erros',
		departamento: '6',
		mensagens: [
			`Quando o equipamento fica travado nessa mensagem, significa que o correu algum problema no sensor de leitura de cartão. Isso pode ter ocorrido devido a ter forçado o cartão na maquinha, algum cartão velho pode ter quebrado alguma parte dentro do equipamento ou até mesmo alguma pancada no equipamento pode ocasionar esse problema. Neste caso será necessário enviar o equipamento para nossa assistência técnica de Diadema, para analisar o que pode ter ocorrido e efetuar o conserto do equipamento.`,
		]
	},
	{
		val: 'FINALIZACAO',
		text: 'Finalização',
		departamento: '6',
		mensagens: [
			`Devido a ausência de resposta o atendimento será encerrado. Caso necessite, por favor entre em contato novamente.`,
			`Disponha, qualquer dúvida, estamos à disposição. Peço que responda a pesquisa de satisfação quando eu finalizar o atendimento. Tenha um ótimo dia.`,
			`Agradeço o contato e fico à disposição.`,
		]
	},
	{
		val: 'PESQUISA_SATISFACAO',
		text: 'Pesquisa de Satisfação',
		departamento: '6',
		mensagens: [
			`No final do atendimento aguarde o encerramento por parte do atendente para participar da pesquisa de satisfação do suporte.`,
		]
	},
	{
		val: 'PINPAD_BLOQUEADO',
		text: 'Pindpad Bloqueado',
		departamento: '6',
		mensagens: [
			`Por motivos de segurança e para evitar eventuais fraudes, somente a Assistência Técnica GERTEC tem autorização para desbloqueá-lo. Nesse caso, o equipamento deverá ser encaminhado para a Assistência Técnica para manutenção. Lembramos que é necessário a emissão de uma nota fiscal de remessa para conserto. O link a seguir contém as instruções e endereço de envio. https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
		]
	},
	{
		val: 'POLITICA_ENVIO',
		text: 'Política de Envio',
		departamento: '6',
		mensagens: [
			`Por favor, para saber mais sobre nossa política de envio de equipamento para conserto em nosso laboratório, consulte o link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`
		]
	},
	{
		val: 'PPC',
		text: 'PPC',
		departamento: '6',
		mensagens: [
			`Procedimento de Instalação do Pinpad: - Entre no site da Gertec e Faça o Download: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe. - Caso seja Windows 10: https://www.gertec.com.br/wp-content/uploads/2017/11/Gertec_PIN_pad_Driver_Installer_win10.exe. Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “WINDOWS EMBEDDED” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Depois da instalação do driver, o PinPAD será reconhecido em uma porta COM de seu computador (Veja no Gerenciador de Dispositivos). - Após o procedimento entrar em contato com o TEF para instalação do Software e Teste.`,
			`Por gentileza efetue o download do driver disponibilizado no link a seguir: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “Windows Embedeed” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Se aparecer para você fazer a ATUALIZAR, então você desinstala primeiro, depois instala como descrito no procedimento acima.`,
			`Por se tratar de um equipamento de segurança, seus sensores são acionados e podem causar o bloqueio quando equipamento sofre algum tipo de avaria física (Exemplo: Tentativa de abertura, queda ou violação) ou até mesmo quando pinpad permanece desligado por um período maior que 06 meses (essa instrução está no manual do produto).`,
		]
	},
	{
		val: 'CONTATO',
		text: 'Contatos',
		departamento: '6',
		mensagens: [
			`A Gertec é o fabricante do equipamento, conosco o atendimento é para suporte técnico do equipamento ou envio de remessa para conserto. Para verificar status de pedido, entre em contato através dos telefones: CENTRAL DE RELACIONAMENTO CREDICARD (MAQUINA POP) (11) 3003-1004 - Capitais e Regiões Metropolitanas 0800 757 1004 - Demais regiões`,
			`Rodrigo Vizelli Coordenador de Assistência Técnica GERTEC Tel.: +55 11 2173-6575 Fax.: +55 11 2173-6538 Cel.: +55 11 99271-1126 E-mail: Rodrigo Vizelli - Gertec (rodrigo.vizelli@gertec.com.br) Skype: gertec_rodrigo.vizelli`,
			`Caro cliente, recomendamos que para consultar o endereço da Assistência Técnica Gertec veja diretamente no site da Gertec. Consulte no site: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Dados da Gertec – Unidade de Serviços Gertec Brasil Ltda. CNPJ 03.654.119/0004-19 I.E 286.502.952.112 I.M 75419 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Obrigado.`,
		]
	},
	{
		val: 'PRAZO_CUSTO',
		text: 'Prazo & Custo',
		departamento: '6',
		mensagens: [
			`Sobre o PRAZO ou CUSTO não tenho como lhe dar uma resposta direta. O Equipamento vai ser recebido pela assistência; vão verificar o problema e farão o orçamento; Autorizando o orçamento; Produto é reparado; Enviado novamente. Para uma informação talvez mais precisa sobre o TEMPO ou CUSTO, vou pedir que ligue no nosso setor de assistência e verifique tudo bem? (11) 2173-6500 - Assistência Técnica - GERTEC.`,
		]
	},
	{
		val: 'PROCEDIMENTO',
		text: 'Procedimentos',
		departamento: '6',
		mensagens: [
			`Para conectar seu Mobi Pin ao Bluetooth de seu celular siga as seguintes instruções: 1) Aperte a sequência de teclas: Amarelo + Verde + Verde ; 2) Coloque a senha: 999999 ; 3) Entre em comunicação ; 4) Escolha : AUTO ; 5) Aperte a tecla : zero(0) ; 6) Ligue o Bluetooth do seu celular e encontre o Mobi Pin na lista de equipamentos conectados ; 7) Confirme o pareamento no Mobi Pin ; 8) Confirme o pareamento no seu celular. Depois de realizado o pareamento do Mobi Pin com o celular, entre em contato com seu sistema de vendas para instalar o aplicativo.`,
			`-Registrador Eletronico de Ponto G1 / G2 Senha PADRÃO DO EQUIPAMENTO: 000000 Caso a senha deste equipamento seja alterada e o usuário não lembre da SENHA alterada o equipamento deve ser enviado para a Assistência - Gertec para fazer o RESET de senha. -Registrador Eletronico de Ponto G3 Senha PADRÃO DO EQUIPAMENTO: 1234 Caso o equipamento tenha sua senha padrão alterada, precisamos que envie um e-mail para: suporte@gertec.com.br Junto do CNPJ e Código do Equipamento, estaremos respondendo o mais rápido possível, solicitando algumas informações. Para ambos os equipamentos: -- Software da Gertec -- Usuário: GERTEC Senha: GERTEC`,
		]
	},
	{
		val: 'SAT',
		text: 'SAT',
		departamento: '6',
		mensagens: [
			`Procedimento de atualização do GerSAT Observação: Estar na versão(interna) permitida na SeFaz(Secretaria da Fazenda) Verifique antes: - Se não existem cupons em memória. - SAT deve estar Vinculado E Ativado. - LED Vermelho DESLIGADO. - LED AC Ligado. - Versão do Ativador ATUALIZADO + Java. https://www.gertec.com.br/wp-content/uploads/2017/09/Ativador_GerSAT_Setup.exe Procedimento abaixo: - Execute como ADMINISTRADOR o ATIVADOR GERSAT. - Entre em OUTRAS FERRAMENTAS. - Coloque o Código de Ativação. - Aperte em ATUALIZAR e aguarde, este procedimento pode levar de 2 a 10 minutos.`,
			`Para abrir o atendimento com a Assistência da Gertec Preciso de algumas informações: CNPJ: Número de Série (Parte SUPERIOR do SAT): Número de Série (Parte INFERIOR do SAT):`,
			`Me informe sobre os LEDs do equipamento (preciso que veja agora no equipamento, não olhe em fotos ou vídeos): - LED Power (Ligado fixo ou Piscando): - LED AC (Ligado ou Desligado): - LED SeFAZ ( Ligado ou Desligado): - LED de Bloqueio ( Ligado, Desligado ou Piscando ):`,
			`Este LED vermelho PISCANDO No SAT indica um problema na memória interna do equipamento chamado de Violação NVRAM e para ser corrigido deve ser enviado para assistência técnica da Gertec. Para o equipamento SAT deve enviar-lo para a Assistencia da Gertec abaixo: Gertec Serviços Ltda. CNPJ 35.819.226/0001-01 IE 286.146.250.119 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Assistência Técnica da Gertec: Para enviar seu equipamento para a Assistência, siga nossa política de envio no link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Se o equipamento estiver na Garantia, você pode verificar nossa política no link abaixo: https://www.gertec.com.br/financeiro/politica-de-garantia/ Caso tenha qualquer dúvida entre em contato com a Gertec, através dos canais: E-mail: astecnica@gertec.com.br Telefone 011 2173-6500.`,
			`Os SATs da Gertec contam com sensores internos contra violação em caso de tentativa de puxar as informações que são enviadas do cliente final para a SEFAZ. Se isso ocorrer o equipamento apresenta um bloqueio de NVRAM (Luz de bloqueio piscando e as demais acesas fixas). Os sensores de violação sendo ativados o equipamento é automaticamente bloqueado e é necessário o envio do equipamento para Assistência Técnica Gertec. Os sensores podem também ser ativados por outros motivos como: Picos de energia elétrica Quedas ou impactos. Em relação a instabilidade de Rede recomendamos que o equipamento em vez de ser ligados diretamente na rede elétrica seja colocada em um estabilizador.`,
		]
	},
	{
		val: 'OUTROS',
		text: 'Outros',
		departamento: '6',
		mensagens: [
			`Bom dia, por favor me forneça o CNPJ da empresa e o Código de Produto do equipamento.`,
			`Peço que você acesse o link: http://connect.teamviewer.com/v13, onde automaticamente irá iniciar um download do "TeamViewerQS", é um executável para que eu consiga realizar o acesso em seu computador, não é necessário instalar.`,
		]
	},
	{
		val: 'APRESENTACAO',
		text: 'Apresentação',
		departamento: '8',
		mensagens: [
			`Bom dia, como posso ajudá-lo?`,
			`Boa tarde, como posso ajudá-lo?`,
		]
	},
	{
		val: 'OUTROS',
		text: 'Outros',
		departamento: '8',
		mensagens: [
			`Em caso de inatividade por 5 minutos o chat será encerrado, fique atento!`,
			`Para encerramento do contrato de TEF ou verificação do valor da cobrança, por gentileza envie um e-mail para pedidos.gerus@gertec.com.br ou entre em contato por ligação ou WhatsApp nos números: 11 99171-1126 / 11 98973-7996.`,
			`Para dúvidas relacionadas a pedidos e-commerce Loja Virtual Gertec, por gentileza entrar em contato por ligação ou WhatsApp através do número 11 99402-3685.`,
		]
	},
	{
		val: 'PROCEDIMENTO',
		text: 'Procedimentos',
		departamento: '8',
		mensagens: [
			`Para emissão de 2ª via de boleto, você poderá realizar o seu cadastro no nosso site, por gentileza seguir os seguintes passos:
  1. Acessar o site https://www.gertec.com.br/
  2. Role a tela até a “Área do cliente”, clique em “2ª via do boleto” e realize o seu cadastro, seja com CPF ou CNPJ.
  3. Ao efetuar o login após estar cadastrado, basta ir em "Adicionar/Remover CPF-CNPJ", digitar o número do CPF/CNPJ em que o boleto está cadastrado, clicar em "Adicionar" e depois em "Enviar".
  4. Após, vá em “Emissão de boleto” e selecione o seu CNPJ clicando na barra de rolagem.
  5. Depois de selecionado, é só clicar em “Gertec B. Serviços” e será direcionado aos boletos pendentes.
Caso não consiga acessar seu cadastro, tente redefinir a senha. Se isso já foi feito e mesmo assim continua sem acesso, pode realizar um novo cadastro para acessar.`,
		]
	},
	{
		val: 'FINALIZACAO',
		text: 'Finalização',
		departamento: '8',
		mensagens: [
			`Há algo mais em que posso ajudar?`,
			`Então nos informe de forma objetiva para melhor atendê-lo.`,
			`Ok, a Gertec agradece seu contato, tenha um ótimo dia!`,
			`Ok, a Gertec agradece seu contato, tenha uma ótima tarde!`,
		]
	},
	{
		val: 'AUSENCIA',
		text: 'Ausência',
		departamento: '1',
		mensagens: [
			`Devido ausência, o atendimento será encerrado. Caso necessite, por favor entre em contato novamente.`,
		]
	},
	{
		val: 'CODIGO',
		text: 'Códigos',
		departamento: '1',
		mensagens: [
			`Código 52 - Verifique as atualizações do seu Sistema Operacional e instale; - Reinicie o computador e verifique se não existem novas atualizações; - Realizada as atualizações o drive deve ser instalado corretamente sem problemas, caso continue com alerta tente realizar uma nova instalação.`,
		]
	},
	{
		val: 'CONTATO',
		text: 'Contatos',
		departamento: '1',
		mensagens: [
			`Rodrigo Vizelli Coordenador de Assistência Técnica GERTEC Tel.: +55 11 2173-6575 Fax.: +55 11 2173-6538 Cel.: +55 11 99271-1126 E-mail: Rodrigo Vizelli - Gertec (rodrigo.vizelli@gertec.com.br) Skype: gertec_rodrigo.vizelli`,
		]
	},
	{
		val: 'ASSISTENCIA',
		text: 'Assistência',
		departamento: '1',
		mensagens: [
			`Caro cliente, recomendamos que para consultar o endereço da Assistência Técnica Gertec veja diretamente no site da Gertec. Consulte no site: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Dados da Gertec – Unidade de Serviços Gertec Brasil Ltda. CNPJ 03.654.119/0004-19 I.E 286.502.952.112 I.M 75419 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Obrigado.`,
			`Para enviar seu equipamento para a Assistência, siga nossa política de envio no link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Caso tenha qualquer dúvida entre em contato com a Gertec, através dos canais: E-mail: astecnica@gertec.com.br Telefone 011 2173-6500.`,
		]
	},
	{
		val: 'APRESENTACAO',
		text: 'Apresentação',
		departamento: '1',
		mensagens: [
			`Olá %nome_contato%, peço que não se esqueça de avaliar o atendimento no encerramento do chat. Como posso ajudar?`,
		]
	},
	{
		val: 'POLITICA_ENVIO',
		text: 'Política de Envio',
		departamento: '1',
		mensagens: [
			`Por favor, para saber mais sobre nossa política de envio de equipamento para conserto em nosso laboratório, consulte o link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
		]
	},
	{
		val: 'FINALIZACAO',
		text: 'Finalização',
		departamento: '1',
		mensagens: [
			`Disponha, qualquer dúvida, estamos à disposição. Peço que responda a pesquisa de satisfação quando eu finalizar o atendimento. Tenha um ótimo dia.`,
			`No final do atendimento aguarde o encerramento por parte do atendente para participar da pesquisa de satisfação do suporte.`,
		]
	},
	{
		val: 'PROCEDIMENTO',
		text: 'Procedimentos',
		departamento: '1',
		mensagens: [
			`Por gentileza efetue o download do driver disponibilizado no link a seguir: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “Windows Embedeed” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Se aparecer para você fazer a ATUALIZAR, então você desinstala primeiro, depois instala como descrito no procedimento acima.`,
			`Para conectar seu Mobi Pin ao Bluetooth de seu celular siga as seguintes instruções: 1) Aperte a sequência de teclas: Amarelo + Verde + Verde ; 2) Coloque a senha: 999999 ; 3) Entre em comunicação ; 4) Escolha : AUTO ; 5) Aperte a tecla : zero(0) ; 6) Ligue o Bluetooth do seu celular e encontre o Mobi Pin na lista de equipamentos conectados ; 7) Confirme o pareamento no Mobi Pin ; 8) Confirme o pareamento no seu celular. Depois de realizado o pareamento do Mobi Pin com o celular, entre em contato com seu sistema de vendas para instalar o aplicativo.`,
			`Registrador Eletronico de Ponto G1 / G2 Senha PADRÃO DO EQUIPAMENTO: 000000 Caso a senha deste equipamento seja alterada e o usuário não lembre da SENHA alterada o equipamento deve ser enviado para a Assistência - Gertec para fazer o RESET de senha. -Registrador Eletronico de Ponto G3 Senha PADRÃO DO EQUIPAMENTO: 1234 Caso o equipamento tenha sua senha padrão alterada, precisamos que envie um e-mail para: suporte@gertec.com.br Junto do CNPJ e Código do Equipamento, estaremos respondendo o mais rápido possível, solicitando algumas informações. Para ambos os equipamentos: -- Software da Gertec -- Usuário: GERTEC Senha: GERTEC`,
			`Procedimento de atualização do GerSAT Observação: Estar na versão(interna) permitida na SeFaz(Secretaria da Fazenda) Verifique antes: - Se não existem cupons em memória. - SAT deve estar Vinculado E Ativado. - LED Vermelho DESLIGADO. - LED AC Ligado. - Versão do Ativador ATUALIZADO + Java. https://www.gertec.com.br/wp-content/uploads/2017/09/Ativador_GerSAT_Setup.exe Procedimento abaixo: - Execute como ADMINISTRADOR o ATIVADOR GERSAT. - Entre em OUTRAS FERRAMENTAS. - Coloque o Código de Ativação. - Aperte em ATUALIZAR e aguarde, este procedimento pode levar de 2 a 10 minutos.`,
			`Me informe sobre os LEDs do equipamento (preciso que veja agora no equipamento, não olhe em fotos ou vídeos): - LED Power (Ligado fixo ou Piscando): - LED AC (Ligado ou Desligado): - LED SeFAZ ( Ligado ou Desligado): - LED de Bloqueio ( Ligado, Desligado ou Piscando ):`,
		]
	},
	{
		val: 'FINALIZACAO',
		text: 'Finalização',
		departamento: '7',
		mensagens: [
			`Agradeço o contato e fico à disposição.`,
			`Vou encerrar o atendimento, peço que responda a pesquisa no final, ok?`,
			`Disponha, qualquer dúvida, estamos à disposição. Peço que responda a pesquisa de satisfação quando eu finalizar o atendimento. Tenha um ótimo dia.`,
		]
	},
	{
		val: 'APRESENTACAO',
		text: 'Apresentação',
		departamento: '7',
		mensagens: [
			`Prezado cliente, bom dia! Como posso ajudá-lo?`,
			`Olá %nome_contato%, peço que não se esqueça de avaliar o atendimento no encerramento do chat. Como posso ajudar?`,
		]
	},
	{
		val: 'OUTROS',
		text: 'Outros',
		departamento: '7',
		mensagens: [
			`neste caso, informo que será necessário entrar em contato com o nosso suporte técnico. No momento não é será possível obter um atendimento via chat pois não há nenhum atendente online, sendo assim, peço que ligue no número 011 2575-1000 e acione a opção suporte técnico.`,
			`A garantia expressa funciona da seguinte forma, após a compra do equipamento PPC ( varejo) o cliente tem até 60 dias após a emissão da nota fiscal de venda para realizar o cadastro no site da Gertec, feito o cadastramento correto, a garantia é validada e assim o cliente passa a usufruir da garantia expressa por 6 meses.`,
			`Segue link do site da Gertec, com as instruções e endereço para envio de equipamentos para conserto: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
			`Para que eu possa verificar e lhe posicionar peço a gentileza de informar o número da NF de remessa para conserto enviada/CNPJ.`,
			`O prazo de análise para o envio de orçamento são 10 dias úteis após o recebimento, tem que aguardar o envio por email.`,
			`Nesse caso, você precisa falar com o suporte técnico da Gertec, hoje, devido ao feriado, a unidade está sem expediente, você pode anotar o número para entrar em contato amanhã ? se preferir pode entrar em contato pelo chat novamente amanhã, eles já estarão disponíveis para atendimento`,
		]
	},
	{
		val: 'ASSISTENCIA',
		text: 'Assistência',
		departamento: '7',
		mensagens: [
			`Por favor, para verificar as assistências autorizadas da Gertec mais próximas da sua região, consulte o link: https://www.gertec.com.br/suporte/assistencia-tecnica/`,
			`Para enviar seu equipamento para a Assistência, siga nossa política de envio no link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Caso tenha qualquer dúvida entre em contato com a Gertec, através dos canais: E-mail: astecnica@gertec.com.br Telefone 011 2173-6500.`,
		]
	},
	{
		val: 'CONTATO',
		text: 'Contatos',
		departamento: '7',
		mensagens: [
			`CENTRAL DE RELACIONAMENTO CREDICARD (MAQUINA POP) (11) 3003-1004 - Capitais e Regiões Metropolitanas 0800 757 1004 - Demais regiões`,
			`Rodrigo Vizelli Coordenador de Assistência Técnica GERTEC Tel.: +55 11 2173-6575 Fax.: +55 11 2173-6538 Cel.: +55 11 99271-1126 E-mail: Rodrigo Vizelli - Gertec (rodrigo.vizelli@gertec.com.br) Skype: gertec_rodrigo.vizelli`,
			`Você já entrou em contato com o suporte da Gertec para confirmar se o equipamento precisa ser enviado para assistência técnica?`,
			`Neste caso informo que deverá entrar em contato nos seguintes números : 011 2173-6572 ou 011 2173-6528`,
			`Caro cliente, recomendamos que para consultar o endereço da Assistência Técnica Gertec veja diretamente no site da Gertec. Consulte no site: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Dados da Gertec – Unidade de Serviços Gertec Brasil Ltda. CNPJ 03.654.119/0004-19 I.E 286.502.952.112 I.M 75419 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Obrigado.`,
			`Nesse caso peço por gentileza que entre em contato como nosso suporte no telefone (11) 2575-1000 os mesmos irão te auxiliar nessa questão tudo bem?`,
		]
	},
	{
		val: 'CODIGO',
		text: 'Códigos',
		departamento: '7',
		mensagens: [
			`Código 52 - Verifique as atualizações do seu Sistema Operacional e instale; - Reinicie o computador e verifique se não existem novas atualizações; - Realizada as atualizações o drive deve ser instalado corretamente sem problemas, caso continue com alerta tente realizar uma nova instalação.`,
		]
	},
	{
		val: 'PESQUISA_SATISFACAO',
		text: 'Pesquisa de Satisfação',
		departamento: '7',
		mensagens: [
			`No final do atendimento aguarde o encerramento por parte do atendente para participar da pesquisa de satisfação do suporte.`,
		]
	},
	{
		val: 'POLITICA_ENVIO',
		text: 'Política de Envio',
		departamento: '7',
		mensagens: [
			`Por favor, para saber mais sobre nossa política de envio de equipamento para conserto em nosso laboratório, consulte o link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
		]
	},
	{
		val: 'PROCEDIMENTO',
		text: 'Procedimentos',
		departamento: '7',
		mensagens: [
			`Por gentileza efetue o download do driver disponibilizado no link a seguir: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “Windows Embedeed” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Se aparecer para você fazer a ATUALIZAR, então você desinstala primeiro, depois instala como descrito no procedimento acima.`,
			`Segue abaixo o procedimento de envio de equipamentos para reparo: Para envio de equipamentos a Gertec é necessário a emissão de uma nota fiscal de remessa para conserto, caso o equipamento esteja dentro do prazo de garantia de venda, peço a gentileza de enviar a cópia da NF de compra do equipamento, além disso, é importante que seja emitido um laudo informando o problema que o equipamento está apresentando. Abaixo link com as instruções e endereço de envio: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
			`Para conectar seu Mobi Pin ao Bluetooth de seu celular siga as seguintes instruções: 1) Aperte a sequência de teclas: Amarelo + Verde + Verde ; 2) Coloque a senha: 999999 ; 3) Entre em comunicação ; 4) Escolha : AUTO ; 5) Aperte a tecla : zero(0) ; 6) Ligue o Bluetooth do seu celular e encontre o Mobi Pin na lista de equipamentos conectados ; 7) Confirme o pareamento no Mobi Pin ; 8) Confirme o pareamento no seu celular. Depois de realizado o pareamento do Mobi Pin com o celular, entre em contato com seu sistema de vendas para instalar o aplicativo.`,
		]
	},
	{
		val: 'TRANSFERENCIA',
		text: 'Transferência',
		departamento: '7',
		mensagens: [
			`Certo, vou transferir o atendimento para o suporte da Gertec, verifique com o atendente se eles conseguem te ajudar remotamente ou se é necessário encaminhar o equipamento para assistência técnica, tudo bem?`,
			`Vou transferir o atendimento para o suporte da Gertec lhe auxiliar, um instante ok?`,
		]
	},
	{
		val: 'FINALIZACAO',
		text: 'Finalização',
		departamento: '4',
		mensagens: [
			`Agradeço o contato e fico à disposição.`,
			`Disponha, qualquer dúvida, estamos a disposição. Peço que responda a pesquisa de satisfação quando eu finalizar o atendimento. Tenha um ótimo dia.	`,
		]
	},
	{
		val: 'CODIGO',
		text: 'Códigos',
		departamento: '4',
		mensagens: [
			`Código 52 - Verifique as atualizações do seu Sistema Operacional e instale; - Reinicie o computador e verifique se não existem novas atualizações; - Realizada as atualizações o drive deve ser instalado corretamente sem problemas, caso continue com alerta tente realizar uma nova instalação.`,
		]
	},
	{
		val: 'CONTATO',
		text: 'Contatos',
		departamento: '4',
		mensagens: [
			`Rodrigo Vizelli Coordenador de Assistência Técnica GERTEC Tel.: +55 11 2173-6575 Fax.: +55 11 2173-6538 Cel.: +55 11 99271-1126 E-mail: Rodrigo Vizelli - Gertec (rodrigo.vizelli@gertec.com.br) Skype: gertec_rodrigo.vizelli`,
			`Caro cliente, recomendamos que para consultar o endereço da Assistência Técnica Gertec veja diretamente no site da Gertec. Consulte no site: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Dados da Gertec – Unidade de Serviços Gertec Brasil Ltda. CNPJ 03.654.119/0004-19 I.E 286.502.952.112 I.M 75419 Rua Guaicurus, 145 Vila Conceição Diadema – SP 09911-630 Obrigado.`,
		]
	},
	{
		val: 'ASSISTENCIA',
		text: 'Assistência',
		departamento: '4',
		mensagens: [
			`Para enviar seu equipamento para a Assistência, siga nossa política de envio no link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/ Caso tenha qualquer dúvida entre em contato com a Gertec, através dos canais: E-mail: astecnica@gertec.com.br Telefone 011 2173-6500.`,
		]
	},
	{
		val: 'APRESENTACAO',
		text: 'Apresentação',
		departamento: '4',
		mensagens: [
			`Olá %nome_contato%, peço que não se esqueça de avaliar o atendimento no encerramento do chat. Como posso ajudar?`,
		]
	},
	{
		val: 'PESQUISA_SATISFACAO',
		text: 'Pesquisa de Satisfação',
		departamento: '4',
		mensagens: [
			`No final do atendimento aguarde o encerramento por parte do atendente para participar da pesquisa de satisfação do suporte.`,
		]
	},
	{
		val: 'POLITICA_ENVIO',
		text: 'Política de Envio',
		departamento: '4',
		mensagens: [
			`Por favor, para saber mais sobre nossa política de envio de equipamento para conserto em nosso laboratório, consulte o link: https://www.gertec.com.br/financeiro/politica-de-envio-de-produtos-para-conserto/`,
		]
	},
	{
		val: 'PPC',
		text: 'PPC',
		departamento: '4',
		mensagens: [
			`Procedimento de Instalação do Pinpad: - Entre no site da Gertec e Faça o Download: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe - Caso seja Windows 10: https://www.gertec.com.br/wp-content/uploads/2017/11/Gertec_PIN_pad_Driver_Installer_win10.exe Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “WINDOWS EMBEDDED” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Depois da instalação do driver, o PinPAD será reconhecido em uma porta COM de seu computador (Veja no Gerenciador de Dispositivos). - Após o procedimento entrar em contato com o TEF para instalação do Software e Teste.`,
			`Por gentileza efetue o download do driver disponibilizado no link a seguir: https://www.gertec.com.br/wp-content/uploads/2017/10/PPC_Instalador_Driver_USB_V_2.3.0.9.exe Após efetuar o download do driver execute o instalador com permissão de administrador e instale o mesmo selecionando o modo avançado e então marque a caixa de seleção “Windows Embedeed” e desmarque todas as outras. Após este passo prossiga até o final da instalação. Se aparecer para você fazer a ATUALIZAR, então você desinstala primeiro, depois instala como descrito no procedimento acima.`,
		]
	},
	{
		val: 'PROCEDIMENTO',
		text: 'Procedimentos',
		departamento: '4',
		mensagens: [
			`Para conectar seu Mobi Pin ao Bluetooth de seu celular siga as seguintes instruções: 1) Aperte a sequência de teclas: Amarelo + Verde + Verde ; 2) Coloque a senha: 999999 ; 3) Entre em comunicação ; 4) Escolha : AUTO ; 5) Aperte a tecla : zero(0) ; 6) Ligue o Bluetooth do seu celular e encontre o Mobi Pin na lista de equipamentos conectados ; 7) Confirme o pareamento no Mobi Pin ; 8) Confirme o pareamento no seu celular. Depois de realizado o pareamento do Mobi Pin com o celular, entre em contato com seu sistema de vendas para instalar o aplicativo.`,
			`Registrador Eletronico de Ponto G1 / G2 Senha PADRÃO DO EQUIPAMENTO: 000000 Caso a senha deste equipamento seja alterada e o usuário não lembre da SENHA alterada o equipamento deve ser enviado para a Assistência - Gertec para fazer o RESET de senha. -Registrador Eletronico de Ponto G3 Senha PADRÃO DO EQUIPAMENTO: 1234 Caso o equipamento tenha sua senha padrão alterada, precisamos que envie um e-mail para: suporte@gertec.com.br Junto do CNPJ e Código do Equipamento, estaremos respondendo o mais rápido possível, solicitando algumas informações. Para ambos os equipamentos: -- Software da Gertec -- Usuário: GERTEC Senha: GERTEC`,
		]
	},
	{
		val: 'SAT',
		text: 'SAT',
		departamento: '4',
		mensagens: [
			`Procedimento de atualização do GerSAT Observação: Estar na versão(interna) permitida na SeFaz(Secretaria da Fazenda) Verifique antes: - Se não existem cupons em memória. - SAT deve estar Vinculado E Ativado. - LED Vermelho DESLIGADO. - LED AC Ligado. - Versão do Ativador ATUALIZADO + Java. https://www.gertec.com.br/wp-content/uploads/2017/09/Ativador_GerSAT_Setup.exe Procedimento abaixo: - Execute como ADMINISTRADOR o ATIVADOR GERSAT. - Entre em OUTRAS FERRAMENTAS. - Coloque o Código de Ativação. - Aperte em ATUALIZAR e aguarde, este procedimento pode levar de 2 a 10 minutos.`,
			`Me informe sobre os LEDs do equipamento (preciso que veja agora no equipamento, não olhe em fotos ou vídeos): - LED Power (Ligado fixo ou Piscando): - LED AC (Ligado ou Desligado): - LED SeFAZ ( Ligado ou Desligado): - LED de Bloqueio ( Ligado, Desligado ou Piscando ):`,
		]
	},
];

const getMensagens = () => _allMensagens;

module.exports = {
	getMensagens
}
